import { AttributeFilterItemProps } from "../../../common/interfaces";
import React, { useContext } from "react";

import { FilterContext } from "../../FilterContext";
import { Swatch } from "@glamcorner/components/lib/core/components/Swatch";
import { SwatchContainer } from "@glamcorner/components/lib/core/components/SwatchContainer";
import { compareAttributeFilterOptions } from "../../../common/util";

export const AttributeFilterItemSwatch: React.FC<AttributeFilterItemProps> = ({ attributeFilter }) => {
  const { appliedAttributeFilters, applyAttributeFilter } = useContext(FilterContext);
  const appliedAttributeFilter = appliedAttributeFilters.find(filter => filter.code === attributeFilter.code);
  const currentAppliedOptions = (appliedAttributeFilter && appliedAttributeFilter.options) || [];
  const sortedAvailableOptions = [...attributeFilter.options].sort(compareAttributeFilterOptions);

  const attributeFilterItemOptions = () => {
    return sortedAvailableOptions.map(option => {
      const isActive = !!currentAppliedOptions.find(opt => opt.label === option.label);
      const onSelected = () => {
        applyAttributeFilter({
          ...attributeFilter,
          options: isActive
            ? currentAppliedOptions.filter(opt => opt.label !== option.label)
            : [...currentAppliedOptions, option]
        });
      };

      return <Swatch key={option.value} isSelected={isActive} colour={option.label} onSelect={onSelected} />;
    });
  };

  return <SwatchContainer>{attributeFilterItemOptions()}</SwatchContainer>;
};
